import { render, staticRenderFns } from "./PlotChange.vue?vue&type=template&id=712f6ad8&scoped=true"
import script from "./PlotChange.vue?vue&type=script&lang=ts"
export * from "./PlotChange.vue?vue&type=script&lang=ts"
import style0 from "./PlotChange.vue?vue&type=style&index=0&id=712f6ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f6ad8",
  null
  
)

export default component.exports